// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2IkqO","box":"WorkspacesBox_box__1QR-E","node":"WorkspacesBox_node__UWClP"};